import { Head, router } from '@inertiajs/react'
import React from 'react'
import Layout from './Layout'
import PackageCard from './Components/PackageCard'
import PhoneButton from '../../Components/PhoneButton'

export default function Venue({ account, venue, packages, event_type, filter_fallback, meta }) {
  const handleSelectPackage = (packageId) => {
    router.visit(`/${account.slug}/booking/configure?package_id=${packageId}&venue_id=${venue.id}`)
  }

  const backHref = event_type
    ? `/${account.slug}/booking/occasions/${event_type.slug}`
    : `/${account.slug}/booking`

  return (
    <>
      <Head title={meta.title} />
      <Layout account={account}>
        {venue.image_url && (
          <div className="h-48 overflow-hidden">
            <img src={venue.image_url} alt="" className="w-full h-full object-cover" />
          </div>
        )}

        <div className={`px-4 py-6 ${!venue.image_url ? 'pt-24' : ''}`}>
          <button
            onClick={() => router.visit(backHref)}
            className="text-white/70 text-sm mb-3 inline-flex items-center hover:text-white transition"
          >
            <svg className="w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            {event_type ? `Back to ${event_type.name.toLowerCase()} rooms` : 'Back to venues'}
          </button>
          {event_type && (
            <p className="text-sky-200 text-sm mb-1">
              {event_type.icon && <span aria-hidden="true">{event_type.icon} </span>}
              {event_type.name}
            </p>
          )}
          <h1 className="text-2xl font-bold text-white">{venue.name}</h1>
          {venue.description && (
            <p className="text-sky-200 mt-2">{venue.description}</p>
          )}
          {venue.capacity && (
            <p className="text-sky-200 text-sm mt-2">
              Capacity: up to {venue.capacity} guests
            </p>
          )}
        </div>

        <div className="px-4 pb-8">
          <h2 className="text-lg font-semibold text-white mb-3">Available Packages</h2>
          {filter_fallback && (
            <p className="text-sky-200/80 text-sm mb-3">
              Showing all packages for this room.
            </p>
          )}
          <div className="space-y-4">
            {packages.length > 0 ? (
              packages.map(pkg => (
                <PackageCard
                  key={pkg.id}
                  package={pkg}
                  onClick={() => handleSelectPackage(pkg.id)}
                />
              ))
            ) : (
              <div className="text-center py-8">
                <p className="text-sky-200">No packages available for this venue.</p>
                {account.phone && (
                  <PhoneButton phoneNumber={account.phone} className="mt-4">
                    Call us to discuss your event
                  </PhoneButton>
                )}
              </div>
            )}
          </div>
        </div>

        {account.phone && packages.length > 0 && (
          <div className="px-4 pb-8">
            <PhoneButton
              phoneNumber={account.phone}
              className="!bg-transparent !text-sky-200 hover:!text-white border border-sky-200/30"
            >
              Prefer to call? Speak to our team
            </PhoneButton>
          </div>
        )}
      </Layout>
    </>
  )
}
